import React, { useState, useEffect } from 'react';
import './Header.css';
import Util from './Util';
import Swal from 'sweetalert2';

const Header = ({ auth, onAuth, onLogout}) => {

  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials: "include",
    });

    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout();
      throw new Error("Unauthorized");
    }

    return response;
  };

  useEffect(() => {
  }, [auth]);

  const setAutoRenew = async () => {
    const command = Util.serverName + "/protected/setAutoRenew";
    let renew = !auth.user.autoRenew;

    try {
      const response = await fetchWithAuth(command, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ renew }),
      });

      const data = await response.json();

      if (!response.ok || !data.status) return;

      let newAuth = {
        authenticated: data.status,
        user: data.user,
        globals: auth.globals
      };

      onAuth(newAuth);

    } catch (error) {
      console.log("Error:", error);
    }
  };

  
  const purchaseCredits = async (credits) => {
    try {
      const response = await fetchWithAuth('/protected/createCreditsCheckoutSession', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: auth.user.userId,
          quantity: credits
        }),
      });

      const data = await response.json();

      if (data.status === false) return;

      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Error starting purchase');
      }

    } catch (err) {
      console.error('Purchase error:', err);
      alert('Something went wrong while purchasing credits');
    }
  };

  /*
  const showPurchaseDialog = async () => {
    const { value: quantity } = await Swal.fire({
      title: 'Purchase Units',
      input: 'number',
      inputLabel: 'Enter quantity of units to purchase',
      inputPlaceholder: 'Enter quantity',
      inputAttributes: {
        min: 1,
        step: 1
      },
      showCancelButton: true
    });

    if (quantity) {
      const unitPrice = 5;
      const creditsPerUnit = 12500;
      const totalCost = unitPrice * quantity;
      const totalCredits = creditsPerUnit * quantity;

      Swal.fire({
        title: `Total Cost: $${totalCost}`,
        text: `You will receive ${totalCredits} credits.`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: `Pay $${totalCost}`
      }).then((result) => {
        if (result.isConfirmed) {
          purchaseCredits(quantity);
        }
      });
    }
  };

  const buyCredits = () => {
    showPurchaseDialog();
  };

  */

  const showPurchaseDialog = async () => {
  
    const markup = Number(auth.globals?.markup) || 2;
  
    // How much the customer pays per credit.
    // $0.01 actual AI cost × markup.
    const pricePerCredit = 0.01 * markup;
  
    const { value: purchase } = await Swal.fire({
      title: 'Purchase Credits',
  
      html: `
        <div style="text-align:left;">
  
          <label style="display:block; margin:12px 0;">
            <input type="radio" name="creditOption" value="250" checked>
            <strong>250 credits</strong> — $5.00
          </label>
  
          <label style="display:block; margin:12px 0;">
            <input type="radio" name="creditOption" value="500">
            <strong>500 credits</strong> — $10.00
          </label>
  
          <label style="display:block; margin:12px 0;">
            <input type="radio" name="creditOption" value="1000">
            <strong>1,000 credits</strong> — $20.00
          </label>
  
          <label style="display:block; margin:12px 0;">
            <input type="radio" name="creditOption" value="custom">
            <strong>Custom</strong>
          </label>
  
          <div id="customCreditContainer"
               style="display:none; margin-top:15px;">
  
            <label for="customCredits">
              Number of credits:
            </label>
  
            <input
              id="customCredits"
              type="number"
              min="1"
              step="1"
              placeholder="Enter credits"
              style="width:100%; box-sizing:border-box; margin-top:5px; padding:8px;"
            >
  
            <div id="customPrice"
                 style="margin-top:10px; font-weight:bold;">
              Price: $0.00
            </div>
  
          </div>
  
        </div>
      `,
  
      showCancelButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
  
      didOpen: () => {
  
        const radios =
          document.querySelectorAll('input[name="creditOption"]');
  
        const customContainer =
          document.getElementById('customCreditContainer');
  
        const customCredits =
          document.getElementById('customCredits');
  
        const customPrice =
          document.getElementById('customPrice');
  
        const updateCustomPrice = () => {
  
          const credits = Number(customCredits.value) || 0;
  
          const price = credits * pricePerCredit;
  
          customPrice.textContent =
            `Price: $${price.toFixed(2)}`;
        };
  
        radios.forEach(radio => {
  
          radio.addEventListener('change', () => {
  
            if (radio.value === 'custom' && radio.checked) {
  
              customContainer.style.display = 'block';
              customCredits.focus();
  
              updateCustomPrice();
  
            } else if (radio.checked) {
  
              customContainer.style.display = 'none';
  
            }
  
          });
  
        });
  
        customCredits.addEventListener(
          'input',
          updateCustomPrice
        );
      },
  
      preConfirm: () => {
  
        const selected =
          document.querySelector(
            'input[name="creditOption"]:checked'
          )?.value;
  
        if (!selected) {
          Swal.showValidationMessage(
            'Please select a credit amount.'
          );
          return false;
        }
  
        let credits;
  
        if (selected === 'custom') {
  
          credits = Number(
            document.getElementById('customCredits').value
          );
  
          if (!Number.isInteger(credits) || credits < 50) {
  
            Swal.showValidationMessage(
              'Please enter a valid number of credits. 50 credits minimum.'
            );
  
            return false;
          }
  
        } else {
  
          credits = Number(selected);
  
        }
  
        const price = credits * pricePerCredit;
  
        return {
          credits,
          price
        };
      }
    });
  
    if (!purchase) return;
  
    // Confirmation dialog
    const result = await Swal.fire({
      title: 'Confirm Purchase',
      html: `
        <div style="font-size:18px;">
          You are purchasing
          <strong>${purchase.credits.toLocaleString()}</strong>
          credits.
          <br><br>
          Total cost:
          <strong>$${purchase.price.toFixed(2)}</strong>
        </div>
      `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: `Pay $${purchase.price.toFixed(2)}`,
      cancelButtonText: 'Cancel'
    });
  
    if (result.isConfirmed) {
      purchaseCredits(purchase.credits);
    }
  };
  
  const buyCredits = () => {
    showPurchaseDialog();
  };

  
  const render = () => {
    let creditsRemaining = auth.user?.credits ?? 0;
    creditsRemaining = creditsRemaining/1000;
    creditsRemaining = creditsRemaining.toFixed(3);

    
    if (auth.user.subscribed === true) {
      let buttonText = auth.user.autoRenew ? "Cancel Renewal" : "Renew Automatically";

      const dateStr = new Date(auth.user.stripePeriodEnd).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });

      let renewString = "Renews On:"
      if(auth.user.autoRenew===false)
      {
        renewString = "Cancels On:"
      }

      return (
        <div className="header-token-usage compact-header">

          <div className="subscription-settings compact-section">
            <button onClick={setAutoRenew}>{buttonText}</button>
            <div className="renewal-info">{renewString} {dateStr}</div>
          </div>

          <div className="header-credits compact-section">
            <button onClick={buyCredits}>Buy Credits</button>
            <div className="credit-info">{creditsRemaining} credits</div>
          </div>

          {/*
          <div className="compact-section">
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="details-toggle-btn"
            >
              {showDetails ? "▲" : "▼"}              
            </button>
          </div>
      */}

        </div>
      );
    }


    if (auth.user.sysPage === true) {
      return (
        <div className="header-token-usage compact-header">

          <div className="subscription-settings compact-section">
            <div>System Page</div>
          </div>

          <div className="header-credits compact-section">
            <button onClick={buyCredits}>Buy Credits</button>
            <div className="credit-info">{creditsRemaining} credits</div>
          </div>
        </div>
      );
    }

    return <div></div>;
  };

  return (
    <header className="header compact-main-header">

      <div className="header-right">
        {render()}        
      </div>

    </header>
  );
};

export default Header;


